<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Link Accounts</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label for="searchCustomersInput">Search Customers</label>
      <input type="text" class="form-control" id="searchCustomersInput"
             name="searchCustomersInput"
             ngbAutofocus
             [(ngModel)]="search"
             (ngModelChange)="handleCustomerFilterChange()">
      <div class="form-text text-danger">{{ errors.related_customer_id }}</div>
    </div>

    <!-- Add a fixed-height div to prevent the Relation input from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto">

      <table *ngIf="!hasSearchInput() || (relation.related_customer_id !== null)">
        <tr>
          <td class="pb-2 pr-3 align-top">Information:</td>
          <td class="pb-2">{{ orgConfigService.getOrganizationConfig().customer_facing_linking_instructions }}</td>
        </tr>
        <tr>
          <td class="pr-3 align-top">Verification:</td>
          <td>{{ orgConfigService.getOrganizationConfig().staff_verification_linking_instructions }}</td>
        </tr>
      </table>

      <ng-container *ngIf="hasSearchInput() && (relation.related_customer_id === null)">

        <table class="table table-bordered table-hover">
          <tbody *ngIf="!customerResultsPresent()">
            <tr>
              <td colspan="99">
                {{ loadingCustomers ? 'Loading...' : 'No results' }}
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="customerResultsPresent()">
            <tr style="cursor:pointer"
                *ngFor="let customer of filteredCustomerResults()"
                (click)="selectRelatedCustomer(customer)">
              <td>
                {{ customer.first_name }} {{ customer.last_name }}
                <span class="text-muted">
                  {{ dateStringFromISO8601(customer.birthday )}}
                  <span *ngIf="customer.email">- {{ customer.email }}</span>
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="alert alert-info" *ngIf="!loadingCustomers && hasRecentActivityFilter()">
          Only recently-active customers are being shown.
          <a href="#" (click)="$event.preventDefault(); handleExpandSearch();">
            Expand search to all customers.
          </a>
        </div>

      </ng-container>

    </div>

    <div class="form-group">
      <label for="relationTypeInput">The above customer is {{ customer.first_name }}'s:</label>
      <select class="custom-select" id="relationTypeInput"
              [(ngModel)]="relation.relation">
        <option [value]="null">---</option>
        <option *ngFor="let relationType of orgConfigService.getAllowedRelations()"
                [value]="relationType">{{ getRelationTypeDisplay(relationType) }}</option>
      </select>
      <div class="form-text text-danger">{{ errors.relation }}</div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingRelationSubmit"
            (click)="handleSave()"
            [disabled]="!validInputSelected()"
            [class.disabled]="!validInputSelected()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingRelationSubmit">
      Loading...
    </button>
  </div>

</ng-container>
